import { render } from "./BasicDropdown.vue?vue&type=template&id=4b30e0a5&scoped=true"
import script from "./BasicDropdown.vue?vue&type=script&lang=js"
export * from "./BasicDropdown.vue?vue&type=script&lang=js"

import "./BasicDropdown.vue?vue&type=style&index=0&id=4b30e0a5&lang=scss&scoped=true"
import "./BasicDropdown.vue?vue&type=style&index=1&id=4b30e0a5&lang=scss"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b30e0a5"]])

export default __exports__